import clsx from 'clsx'
import React from 'react'
import VisualBalanceEmptyState from '../../../../VisualBalanceSheetV2/VisualBalanceEmptyState'
import BlockItem from '../Blocks/BlockItem'
import { VisualBlockListProps } from '../propTypes'
import { useVisualBlocksContext, VisualBlocksProvider } from '../VisualBlocksContext'
import SplitList from './SplitList'
import LoadingState from './LoadingState'

function VisualBlockListContent () {
  const { data, isLoading, classNames, styles } =
    useVisualBlocksContext()

  if (isLoading) {
    return <LoadingState />
  }

  if (!data?.length) {
    return (
      <div
        className={clsx(
          'flex flex-col gap-2 h-full items-center justify-center',
          classNames?.container
        )}
        style={{ minHeight: '500px', ...(styles?.container ?? {}) }}
      >
        <div className='w-full' style={{ maxWidth: '800px' }}>
          <VisualBalanceEmptyState />
        </div>
      </div>
    )
  }

  return (
    <div
      className={clsx('flex h-full w-full items-start', classNames?.container)}
      style={{ minHeight: '500px', gap: '24px', ...(styles?.container ?? {}) }}
    >
      {data.map((item) => (
        <div className='flex flex-1 gap-5' key={item.id}>
          <BlockItem
            labelLocation='inside'
            depth={0}
            fixedWidth='240px'
            label={item.label}
            value={item.value}
            color={item.color}
            labelSize='lg'
          />

          <SplitList item={item} />
        </div>
      ))}
    </div>
  )
}

function PipelineVisualBlockList (props) {
  return (
    <VisualBlocksProvider {...props}>
      <VisualBlockListContent />
    </VisualBlocksProvider>
  )
}

PipelineVisualBlockList.propTypes = VisualBlockListProps

export default PipelineVisualBlockList
